export const PCON_LOGIN_CLIENT_ID: string = 'EGR-IPI';
const PCON_LOGIN_HOST: string = 'login.pcon-solutions.com';
export const PCON_LOGIN_PROFILE_URL: string = 'https://' + PCON_LOGIN_HOST + '/';
export const PCON_LOGIN_USER_API: string = 'https://' + PCON_LOGIN_HOST + '/api/v1/account/user';
export const PCON_LOGIN_ORGANIZATION_API: string = 'https://' + PCON_LOGIN_HOST + '/api/v1/account/organization';
export const PCON_LOGIN_LOGOUT_API: string = 'https://' + PCON_LOGIN_HOST + '/api/v1/logout';

const PCON_UPDATE_API_URL: string = 'https://update.easterngraphics.com/api/v1/';
export const PCON_UPDATE_PACKAGE_URL: string = PCON_UPDATE_API_URL + 'get_package_groups';

export const EAIWS_FALLBACK_LANGUAGES: Array<string> = ['en', 'de', 'fr', 'nl'];


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/Api.ts